import { render, staticRenderFns } from "./edit-small.vue?vue&type=template&id=b15da4e2&scoped=true&"
import script from "./edit-small.vue?vue&type=script&lang=js&"
export * from "./edit-small.vue?vue&type=script&lang=js&"
import style0 from "./edit-small.vue?vue&type=style&index=0&id=b15da4e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15da4e2",
  null
  
)

export default component.exports